import { useState } from "react";
import authService from "../../services/authService";
import { Alert, Button, Card, Form, InputGroup, Spinner, Toast, ToastContainer } from "react-bootstrap";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");

    const handleToast = (message) => {
        setToastMessage(message);
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
    };

    // Send OTP
    const handleSendOtp = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError("");
        const response = await authService.sendOtp(email);

        if (response.success) {
            handleToast(response.message);
            setStep(2);
        } else {
            setError(response.message);
        }
        setLoading(false);
    };

    // Verify OTP
    const handleVerifyOtp = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError("");
        const response = await authService.verifyOtp(email, otp);

        if (response.success) {
            handleToast(response.message);
            setStep(3);
        } else {
            setError(response.message);
        }
        setLoading(false);
    };

    // Reset Password
    const handleResetPassword = async (event) => {
        event.preventDefault();
        const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

        if (!passwordPattern.test(newPassword)) {
            setError(
                "Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, a number, and a special character."
            );
            return;
        }

        setLoading(true);
        setError("");

        try {
            const response = await authService.resetPassword(email, newPassword);

            if (response.success) {
                handleToast(response.message);
                window.location.href = "/";
            } else {
                setError(response.message);
            }
        } catch (err) {
            setError("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="d-flex justify-content-center align-items-center vh-100">
            <Card style={{ width: "25rem", padding: "20px" }}>
                <Card.Body>
                    <h3 className="text-center mb-3">
                        {step === 1 ? "Forgot Password" : step === 2 ? "Enter OTP" : "Reset Password"}
                    </h3>

                    {error && <Alert variant="danger">{error}</Alert>}

                    {step === 1 && (
                        <Form onSubmit={handleSendOtp}>
                            <Form.Group className="mb-3">
                                <InputGroup>
                                    <Form.Control
                                        type="email"
                                        placeholder="Enter your email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </InputGroup>
                            </Form.Group>
                            <Button type="submit" variant="danger" className="w-100" disabled={loading}>
                                {loading ? <Spinner animation="border" size="sm" /> : "Send OTP"}
                            </Button>
                        </Form>
                    )}

                    {step === 2 && (
                        <Form onSubmit={handleVerifyOtp}>
                            <Form.Group className="mb-3">
                                <InputGroup>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter OTP"
                                        value={otp}
                                        onChange={(e) => setOtp(e.target.value)}
                                        required
                                    />
                                </InputGroup>
                            </Form.Group>
                            <Button type="submit" variant="danger" className="w-100" disabled={loading}>
                                {loading ? <Spinner animation="border" size="sm" /> : "Verify OTP"}
                            </Button>
                        </Form>
                    )}

                    {step === 3 && (
                        <Form onSubmit={handleResetPassword}>
                            <Form.Group className="mb-3">
                                <InputGroup>
                                    <Form.Control
                                        type="password"
                                        placeholder="Enter new password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        required
                                        pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
                                        title="Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, a number, and a special character."
                                    />
                                </InputGroup>
                            </Form.Group>
                            <Button type="submit" variant="danger" className="w-100" disabled={loading}>
                                {loading ? <Spinner animation="border" size="sm" /> : "Reset Password"}
                            </Button>
                        </Form>
                    )}
                </Card.Body>
            </Card>

            {/* Toast Notification */}
            <ToastContainer position="top-center" className="p-3">
                <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide>
                    <Toast.Body>{toastMessage}</Toast.Body>
                </Toast>
            </ToastContainer>
        </div>
    );
};

export default ForgotPassword;
